export default "__VITE_ASSET__mn$_MgQD__"